/**
 * Collapses long product descriptions to 2 lines with a read more toggle.
 */

/**
 * @param {HTMLElement} root
 */
function initProductDescriptionBlock(root) {
  if (root.dataset.readMoreInitialized === 'true') return;

  const content = root.querySelector('.product-description__content');
  const toggle = root.querySelector('.product-description__toggle');

  if (
    !(content instanceof HTMLElement) ||
    !(toggle instanceof HTMLButtonElement)
  ) {
    return;
  }

  root.dataset.readMoreInitialized = 'true';
  root.classList.add('product-description--collapsed');

  const isOverflowing = content.scrollHeight > content.clientHeight + 1;

  if (!isOverflowing) {
    root.classList.remove('product-description--collapsed');
    toggle.remove();
    return;
  }

  const readMoreLabel = toggle.dataset.readMoreLabel || 'Read more';
  const readLessLabel = toggle.dataset.readLessLabel || 'Read less';

  toggle.hidden = false;
  toggle.textContent = readMoreLabel;
  toggle.setAttribute('aria-expanded', 'false');

  toggle.addEventListener('click', () => {
    const expanded = root.classList.toggle('product-description--expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? readLessLabel : readMoreLabel;
  });
}

/**
 * Initialize read more for all product description blocks on the page.
 */
function initProductDescriptionBlocks() {
  document
    .querySelectorAll('.product-description[data-read-more]')
    .forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      initProductDescriptionBlock(root);
    });
}

document.addEventListener('DOMContentLoaded', initProductDescriptionBlocks);
document.addEventListener('shopify:section:load', initProductDescriptionBlocks);
document.addEventListener('shopify:block:select', initProductDescriptionBlocks);
